import { useGetMainList } from "ra-core"
import { createContext, FC, useCallback, useContext, useState } from "react"
import { LineChartResponseDto, TimeRangeType } from "@/gen/api/metrics"


export interface MetricsControllerProps {
  timeRange: TimeRangeType;
  setTimeRange: (x:TimeRangeType) => void;
  setDbId: (x:number) => void;
  refetch: () => void;
  dbsizeData?: LineChartResponseDto;  
  indexsizeData?: LineChartResponseDto; 
  rowcountData?: LineChartResponseDto; 
  observeDbsize: (x:boolean) => void;
  observeIndexsize: (x:boolean) => void;
  observeRowcount: (x:boolean) => void;
}

const MetricsContext = createContext<MetricsControllerProps>({
  timeRange: TimeRangeType.Week,
  setTimeRange: () => {},
  setDbId: () => {},
  refetch: () => {},
  observeDbsize: () => {},
  observeIndexsize: () => {},
  observeRowcount: () => {},
})

export const MetricsContextProvider: FC<{ value: MetricsControllerProps }> = ({ children, value }) => {
  return (
    <MetricsContext.Provider value={value}>
      {children}
    </MetricsContext.Provider>
  )
}

const defaultPage = {page:1, perPage:1}
const defaultSort = {field:'id', order:'ASC'}

export const useMetricsController = ({ preDbId }: {preDbId?:number}): MetricsControllerProps => {
  const [timeRange, setTimeRange] = useState(TimeRangeType.Week)
  const [dbId, setDbId] = useState(preDbId || -1)
  const [endTime, setEndTime] = useState(new Date().toISOString())
  const [hotDbsize, setHotDbsize] = useState(false)
  const [hotIndexsize, setHotIndexsize] = useState(false)
  const [hotRowcount, setHotRowcount] = useState(false)

  const refetch = useCallback(() => {
    setEndTime(new Date().toISOString())
  }, [])

  const filterParam = dbId > 0 ? { 
    dbId, 
    endTime,
    timeRangeType: timeRange, 
  } : {}

  const { data: dbsizeDataBag } = useGetMainList((dbId > 0 && hotDbsize) ? 'dbmetrics-dbsize' : 'noop', defaultPage, defaultSort, filterParam)
  const dbsizeData = Object.values(dbsizeDataBag || {})[0] as LineChartResponseDto | undefined
  const { data: indexsizeDataBag} = useGetMainList((dbId > 0 && hotIndexsize) ? 'dbmetrics-indexsize' : 'noop', defaultPage, defaultSort, filterParam)
  const indexsizeData = Object.values(indexsizeDataBag || {})[0] as LineChartResponseDto | undefined
  const { data: rowcountDataBag } = useGetMainList((dbId > 0 && hotRowcount) ? 'dbmetrics-rowcount' : 'noop', defaultPage, defaultSort, filterParam)
  const rowcountData = Object.values(rowcountDataBag || {})[0] as LineChartResponseDto | undefined
  
  return {
    timeRange,
    setTimeRange,
    setDbId,
    dbsizeData,
    indexsizeData,
    rowcountData,
    refetch,
    observeDbsize: setHotDbsize,
    observeIndexsize: setHotIndexsize,
    observeRowcount: setHotRowcount,
  }
}

export const useMetricsContext = () => useContext(MetricsContext);

